import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { formMappings } from "../../../config/formMappings";

export default function CheckInCount() {
  const entries = useSelector((state: RootState) => state.formEntries.entries);

  const activeFormName = useSelector(
    (state: RootState) => state.formEntries.activeFormName || ""
  );

  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const checkedInFieldKey =
    formMapping?.fieldMappings?.["Checked In"] || "opjkc3";

  // Calculate the number of "Checked In" values that are true
  const totalCheckedIn = entries.reduce((total, entry) => {
    // Check both the field key and "Checked In" (in case API service mapped it)
    const checkedInArray =
      entry.meta[checkedInFieldKey] || entry.meta["Checked In"] || [];
    const countTrue = checkedInArray.filter(
      (value: string) => value === "true"
    ).length;
    return total + countTrue;
  }, 0);

  return (
    <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
      <dt className="truncate text-sm font-medium text-gray-500">Checked In</dt>
      <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
        {totalCheckedIn}
      </dd>
    </div>
  );
}
